import * as actionTypes from "../../actions/actionTypes";

const signUp = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SIGN_UP_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default signUp;
